/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plain_Text_Import_End_Event_Char_LabelInputs */



/**
* | output |
* | --- |
* | "End Event On Character" |
*
* @param {Plain_Text_Import_End_Event_Char_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const plain_text_import_end_event_char_label = /** @type {((inputs?: Plain_Text_Import_End_Event_Char_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plain_Text_Import_End_Event_Char_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Terminer l'evenement sur caractere")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignis für Charakter beenden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Termina l'evento sul personaggio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Завершение события на персонаже")
	if (locale === "es") return /** @type {LocalizedString} */ ("Evento final en el personaje")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("角色结束事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("キャラクターのイベント終了")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चरित्र पर घटना समाप्त करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Finalizar evento no personagem")
	return /** @type {LocalizedString} */ ("End Event On Character")
});